














import { Component, Mixins } from 'vue-property-decorator';
import propsMixin from '../propsMixim';

@Component
export default class SelectorButton extends Mixins(propsMixin) {
  get style() {
    const { bgColor, active } = this;
    if (!bgColor && !active) return {};
    const color = `#${bgColor}`;
    return {
      backgroundColor: active ? '#FFF' : color,
      borderColor: active ? '#DDD' : color,
    };
  }

  get activeClass() {
    const { active } = this;
    return [active ? 'selector-button_active' : ''];
  }

  clickButton() {
    if (!this.active) this.$emit('click');
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/remote-edu/calendar/components/selector/components/button/SelectorButton.vue